import { AccountLockOutlineIcon } from './AccountLockOutlineIcon';

/**
 * author: Michael Irigoyen
 * id F0E25FF6-2E45-4F3D-B9E3-6F251A6B1651
 * name account-lock-outline
 * version: 4.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-lock-outline.svg
 * tags
 * - Account / User 
 * - Lock 
 */
export const PersonLockOutlineIcon = AccountLockOutlineIcon;
export default PersonLockOutlineIcon